import React, {Component} from 'react';
import { Link } from 'react-router-dom';
import TapTheCap from './TapTheCap';
import CustomSlide1 from './CustomSlide1';
import CustomSlide2 from './CustomSlide2';
import CustomSlide3 from './CustomSlide3';
import CustomSlide4 from './CustomSlide4';

class ProductSlider extends Component {
    getDecorIconPath(index) {
        const iconPaths = [
            '/assets/img/product-slider/prod1.png',
            '/assets/img/product-slider/prod2.png',
            '/assets/img/product-slider/prod3.png',
            '/assets/img/product-slider/prod4.png',
            '/assets/img/product-slider/prod5.png',
        ];

        return iconPaths[index % iconPaths.length];
    }

    getDecorIconPosition(index) {
        return 'ps-product-slider__decor--center';
    }

    getProducts() {
        return (Array.isArray(this.props.products) ? this.props.products : [])
            .filter((product) => product && (product.display_image || product.product_image || product.image_path));
    }

    getProductImage(product) {
        return product.display_image || product.product_image || product.image_path || '/assets/img/byos-no-image.png';
    }

    getProductLink(product) {
        const variationId = product.variation_id || product.product_id || product.id || '';
        const name = product.product_name || 'Product';
        return `/details/${Buffer.from(String(variationId)).toString('base64')}/${name}`;
    }

    getProductCopy(product, index) {
        const title = (product.product_name || `Product ${index + 1}`).trim();
        const subtitle = (
            product.product_subtitle ||
            product.short_description ||
            product.category_name ||
            product.brand_name ||
            product.tagline ||
            ''
        ).trim();

        return {title, subtitle};
    }

    getPrice(product) {
        const pricing = product.pricing || {};
        return {
            sale: pricing.offer_price || product.offer_price || '',
            regular: pricing.selling_price || product.selling_price || '',
        };
    }

    getRating(product) {
        const value = Number(product.rating || product.rattings || product.average_rating || product.review_rating || 4.8);
        if (Number.isNaN(value)) {
            return 4.8;
        }
        return Math.max(0, Math.min(5, value));
    }

    getReviewCount(product) {
        const count = Number(product.review_count || product.total_reviews || product.total_review || product.reviewCount || 0);
        return Number.isNaN(count) ? 0 : count;
    }

    renderStars(rating) {
        return Array.from({length: 5}).map((_, index) => {
            const threshold = index + 1;
            const isActive = rating >= threshold;
            const isHalf = !isActive && rating > index && rating < threshold;

            return (
                <span
                    className={`ps-product-slider__star ${isActive ? 'ps-product-slider__star--active' : ''} ${isHalf ? 'ps-product-slider__star--half' : ''}`}
                    key={`star-${index}`}
                    aria-hidden="true"
                >
                    <i className={`fa ${isHalf ? 'fa-star-half-o' : 'fa-star'}`}></i>
                </span>
            );
        });
    }

    render() {
        const products = this.getProducts();

        if (products.length === 0) {
            return null;
        }

        return (
            <div>
                <div className="container">
                    <section className="ps-product-slider ps-product-slider--bestsellers" aria-labelledby="product-slider-title">
                    <img className="ps-product-slider__corner ps-product-slider__corner--left" src="/assets/img/leaf-1.png" alt="" aria-hidden="true" />
                    <img className="ps-product-slider__corner ps-product-slider__corner--right" src="/assets/img/leaf-1.png" alt="" aria-hidden="true" />

                    <div className="ps-product-slider__header">
                        <div className="ps-product-slider__eyebrowRow">
                            <img className="ps-product-slider__leaf" src="/assets/img/leaf-2.png" alt="" aria-hidden="true" />
                            <span className="ps-product-slider__eyebrow">OUR BESTSELLERS</span>
                            <img className="ps-product-slider__leaf ps-product-slider__leaf--right" src="/assets/img/leaf-2.png" alt="" aria-hidden="true" />
                        </div>
                        <h3 className="ps-product-slider__title ps-product-slider__titleText" id="product-slider-title">
                            <span className="ps-product-slider__titleLead">Pure Goodness</span>{' '}
                            <span className="ps-product-slider__titleFor">for</span>{' '}
                            <span className="ps-product-slider__titleTail">Every Home</span>
                        </h3>
                        <img className="ps-product-slider__titleLine" src="/assets/img/about/about-line.png" alt="" aria-hidden="true" />
                        <p className="ps-product-slider__subtitle">Carefully crafted. Naturally yours.</p>
                    </div>

                    <div className="ps-product-slider__carouselWrap">
                        <div
                            className="owl-carousel-product owl-carousel ps-product-slider__carousel"
                            data-owl-auto="false"
                            data-owl-loop="false"
                            data-owl-speed="12000"
                            data-owl-gap="10"
                            data-owl-nav="true"
                            data-owl-dots="false"
                            data-owl-item="2"
                            data-owl-item-xs="2"
                            data-owl-item-sm="3"
                            data-owl-item-md="4"
                            data-owl-item-lg="6"
                            data-owl-item-xl="6"
                            data-owl-duration="1000"
                            data-owl-mousedrag="on"
                        >
                            {products.map((product, index) => {
                                const copy = this.getProductCopy(product, index);
                                const image = this.getProductImage(product);
                                const link = this.getProductLink(product);
                                const {sale, regular} = this.getPrice(product);
                                const rating = this.getRating(product);
                                const reviewCount = this.getReviewCount(product);
                                const decorIcon = this.getDecorIconPath(index);
                                const decorPosition = this.getDecorIconPosition(index);

                                return (
                                    <div className="ps-section__product" key={`${product.variation_id || product.product_id || index}-${index}`}>
                                        <article className="ps-product-slider__card">
                                            <Link className="ps-product-slider__mediaLink" to={link} aria-label={copy.title}>
                                                <div className="ps-product-slider__media">
                                                    <img className="ps-product-slider__image" src={image} alt={copy.title} loading="lazy" />
                                                </div>
                                            </Link>

                                            <div className={`ps-product-slider__decor ${decorPosition}`} aria-hidden="true">
                                                <img className="ps-product-slider__decorImage" src={decorIcon} alt="" />
                                            </div>

                                            <div className="ps-product-slider__content">
                                                <h4 className="ps-product-slider__productTitle">
                                                    <Link to={link}>{copy.title}</Link>
                                                </h4>
                                                {copy.subtitle ? (
                                                    <p className="ps-product-slider__productSubtitle">{copy.subtitle}</p>
                                                ) : null}

                                                <div className="ps-product-slider__rating" aria-label={`${rating.toFixed(1)} out of 5 stars`}>
                                                    <div className="ps-product-slider__stars">{this.renderStars(rating)}</div>
                                                    <span className="ps-product-slider__reviewCount">({reviewCount})</span>
                                                </div>

                                                <div className="ps-product-slider__priceRow">
                                                    {sale ? <span className="ps-product-slider__price">₹{sale}</span> : null}
                                                    {regular ? <span className="ps-product-slider__strike">₹{regular}</span> : null}
                                                </div>

                                                <Link className="ps-product-slider__button" to={link}>
                                                    Shop Now
                                                    <img src="/assets/img/right-arrow-small.png" alt="" aria-hidden="true" />
                                                </Link>
                                            </div>
                                        </article>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    </section>
                </div>

                <TapTheCap products={products} />
                <CustomSlide1 />
                 <div className="container">
                    <CustomSlide2 />
                </div>
                
                <CustomSlide4 />
                <CustomSlide3 />
            </div>
        );
    }
}

export default ProductSlider;
